import { filter, map, Subject } from 'rxjs';
import {
  findSegmentByNumericValue,
  getCookie,
  getData,
  SEGMENT,
  setData
} from './utils';
import { SEGMENTS } from './config';
import { PixelsVideoEvent } from '../../constants/Video';

export const deDupeLastVal = () => {
  let val: number | string;
  return (x: number | string) => {
    if (x !== val) {
      val = x;
      return true;
    }
    return false;
  };
};

const mapToSegment = (segment: SEGMENT) =>
  (x: number) =>
    findSegmentByNumericValue(segment, x)[0];

export const completion = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
  const timeChange$ = sub.pipe(
    filter(([type]) => type === PixelsVideoEvent.TIME),
    map(([, { position, duration }]) => Math.ceil(position / duration * 100)),
    filter(deDupeLastVal()),
    map(mapToSegment(SEGMENTS.completion)),
    filter(deDupeLastVal()),
  );

  timeChange$.subscribe((percentile) => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;
    const data = getData(storageKey);

    // segmentLog(`Completion: ${percentile.toString()}`);

    setData(storageKey, {
      ...data,
      completion: {
        value: percentile
      }
    });
  });
};